import axios from "axios"

export default class MasterRoomRAPI {
    static async supplyByItem(itemId) {
        return (await axios.get('master_services/supply_list/?itemId=' + itemId)).data
    }
    static async addSupply(serviceId, barcode, count) {
        return (await axios.get('master_services/add_supply/?serviceId=' + serviceId + '&barcode=' + barcode + '&count=' + count)).data
    }
}